import React, { useEffect, useState } from "react";
import { adminMenuGaps } from "../../lib/adminApi";

const SEV_TONE = {
  high: "border-red-500/40 text-red-300",
  medium: "border-yellow-500/40 text-yellow-300",
  low: "border-white/15 text-white/60",
};

export default function AdminMenuGaps() {
  const [data, setData] = useState(null);
  useEffect(() => { adminMenuGaps().then(setData); }, []);

  if (!data) return <div className="p-10 text-white/40">Loading...</div>;

  return (
    <div className="px-5 md:px-10 py-8 max-w-6xl" data-testid="admin-menu-gaps">
      <header className="mb-6">
        <p className="overline text-[#C17F59] mb-2">Menu Gap Analysis</p>
        <h1 className="font-display text-4xl">Where the shelf is thin.</h1>
        <p className="text-sm text-white/55 mt-2 max-w-2xl">Category, country, and price-band coverage. The atlas as strategy engine.</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {data.gaps.map((g, i) => (
          <div key={i} className={`bg-[#15171A] border p-5 ${SEV_TONE[g.severity]}`} data-testid={`gap-${i}`}>
            <p className="overline mb-2 text-[#C17F59]">{g.severity} · {g.type}</p>
            <h3 className="font-display text-2xl mb-2">{g.label}</h3>
            <p className="text-sm text-white/70">{g.detail}</p>
          </div>
        ))}
        {data.gaps.length === 0 && <p className="text-white/50">No gaps detected — nice menu balance.</p>}
      </div>
    </div>
  );
}
